export default __webpack_public_path__ + "static/media/transaction-failed-img.9225430b.png";